import { useState } from "react";
import { Button } from "react-bootstrap";
import { IoCloseOutline } from "react-icons/io5";
import ModalConfirmation from "../../Home/UserPages/UserPage/RemoveButton/ModalConfirmation";

const ExitButton = () => {
  const [showModal, setShowModal] = useState(false);

  const handleModal = (handle: boolean) => {
    setShowModal(handle);
  };

  return (
    <Button
      type="button"
      variant="info"
      style={{ marginLeft: "3px", backgroundColor: "#D35747", color: "white" }}
    >
      <IoCloseOutline onClick={() => setShowModal(true)} />
      <ModalConfirmation
        show={showModal}
        changeModal={handleModal}
        id={window.location.href.split("/")[5]}
        dash={true}
      />
    </Button>
  );
};

export default ExitButton;
